import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import styles from '../scss/modules/components/button.icon.module.scss';
export default (props) => {
    // if(props.href)
    // {
    //   return <>
    //     <a
    //       href={props.href}
    //       target={props.target}
    //       rel={props.rel}
    //       className={`${styles.iconButton} ${props.color === 'invisible' ? 'invisible' : styles[props.color]} ${props.muted && styles.muted}`}
    //       onClick={props.onClick}
    //       title={props.title}
    //     >
    //       {props.children}
    //     </a>
    //   </>
    // }
    return _jsx(_Fragment, { children: _jsx("button", { type: props.submit ? 'submit' : 'button', className: [
                props.icon ? styles.iconButton : styles.button,
                props.color === 'invisible' ? 'invisible' : styles[props.color],
                props.outline && styles.outline,
                props.muted && styles.muted,
                props.selected && styles.selected,
                props.ms ? `ms-${props.ms}` : '',
                props.me ? `me-${props.me}` : '',
                props.mt ? `mt-${props.mt}` : '',
                props.mb ? `mb-${props.mb}` : '',
                props.w100 ? 'w-100' : '',
            ].join(' '), style: props.minWidth ? { 'minWidth': `${props.minWidth}px` } : undefined, onClick: props.onClick, title: props.title, disabled: props.disabled, children: props.children }) });
};
